import { render, staticRenderFns } from "@/modules/Newcase/templates/formsite-create-case.html?vue&type=template&id=4da21b34&scoped=true&"
import script from "@/modules/Newcase/scripts/formsite-create-case.ts?vue&type=script&lang=js&"
export * from "@/modules/Newcase/scripts/formsite-create-case.ts?vue&type=script&lang=js&"
import style0 from "@/modules/Newcase/styles/formsite-create-case.scss?vue&type=style&index=0&id=4da21b34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da21b34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
